import React from "react";
import { ApolloProvider } from "@apollo/client";
// import { Redirect } from "react-router-dom";

// Custom.
import { VoApp, VoApi, VoAuth, VoRouter, wrapPromise } from "@vocollege/app";
// import wrapPromise from "utils/wrapPromise";
import routes from "pages/routes";
import Utils from "services/Utils";

interface AuthGuardProps {
  children?: React.ReactNode;
}

VoApp.configure(
  {
    APP_VERSION: process.env.REACT_APP_VERSION,

    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
    API_GRAPHQL: process.env.REACT_APP_API_GRAPHQL,

    DOCS_BASE_URL: process.env.REACT_APP_DOCS_BASE_URL,
    DOCS_ENDPOINT: process.env.REACT_APP_DOCS_ENDPOINT,
    DOCS_GRAPHQL: process.env.REACT_APP_DOCS_GRAPHQL,
    DOCS_PUBLIC_DISKS: process.env.REACT_APP_DOCS_PUBLIC_DISKS,
    DOCS_PRIVATE_DISKS: process.env.REACT_APP_DOCS_PRIVATE_DISKS,
    AWS_BUCKET_VOFRONT_FILES: process.env.REACT_APP_AWS_BUCKET_VOFRONT_FILES,
    AWS_BUCKET_VODOCS_FILES: process.env.REACT_APP_AWS_BUCKET_VODOCS_FILES,

    AUTH_CLIENT_ID: process.env.REACT_APP_AUTH_CLIENT_ID,
    AUTH_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL,
    AUTH_ENDPOINT: process.env.REACT_APP_AUTH_ENDPOINT,
    AUTH_DOMAIN: process.env.REACT_APP_AUTH_DOMAIN,

    AUTH_STORAGE_REFRESH_TOKEN:
      process.env.REACT_APP_AUTH_STORAGE_REFRESH_TOKEN,
    AUTH_STORAGE_ACCESS_TOKEN: process.env.REACT_APP_AUTH_STORAGE_ACCESS_TOKEN,

    BASE_URL: process.env.REACT_APP_BASE_URL,
    AUTH: process.env.REACT_APP_AUTH,
    LOGIN: process.env.REACT_APP_LOGIN,
    HOME: process.env.REACT_APP_HOME,
  },
  routes
);

const promise = VoRouter.isAuthRoute() ? VoAuth.auth() : VoAuth.check();
const resource = wrapPromise(promise);

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  resource.read();

  if (VoRouter.isAuthRoute()) {
    let redirectTo = Utils.getRedirectUrl();
    if (redirectTo) {
      window.location.href = redirectTo;
      Utils.removeRedirectUrl();
    } else {
      VoRouter.redirectToHome();
    }
    return <></>;
  }

  Utils.setRedirectUrl();

  return (
    <ApolloProvider client={VoApi.graphqlClient}>{children}</ApolloProvider>
  );
};

export default AuthGuard;
